import "./scripts/step-tab.js";
import "./scripts/user-register-form.js";
import "./scripts/order-form.js";
import "./scripts/check-pass.js";

// You may start using jQuery $ immediately after this file is loaded
console.log("This is main.js");

jQuery(document).ready(function ($) {
  // Mobile menu
  $("#button-open-mobile-menu").on("click", function () {
    $(this).attr("aria-pressed", true);
    $(this).attr("aria-expanded", true);
    $("#mobile-panel").fadeIn();
    $("body").addClass("freeze");
  });

  $("#button-close-mobile-menu").on("click", function () {
    $("#button-open-mobile-menu").attr("aria-pressed", false);
    $("#button-open-mobile-menu").attr("aria-expanded", false);
    $("#mobile-panel").fadeOut();
    $("body").removeClass("freeze");
  });

  // Translate menu
  $(".button-open-translate").on("click", function () {
    $(this).siblings(".translate-menu").show();
  });

  $(".button-close-translate").on("click", function () {
    console.log("clicked close");
    $(this).parents(".translate-menu").hide();
  });

  // Translate container move on resize
  $(window).on("resize", function () {
    let myTimeout;

    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );

    clearTimeout(myTimeout);

    myTimeout = setTimeout(() => {
      if (vw > 1023) {
        $("#google_translate_element").appendTo("#translate-container-desktop");
      } else {
        $("#google_translate_element").appendTo("#translate-container-mobile");
      }
    }, 500);
  });

  $(window).resize();

  $(document).on("click", ".download-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();

    $("body").addClass("modal-open");
    $("#overzicht-modal").fadeIn().attr("aria-hidden", "false");

    const sid = $(this).data("sid");
    const date = $(this).data("date");
    const bestellen = $(this).data("bestellen");
    const terugsturen = $(this).data("terugsturen");
    const orgName = $(this).data("orgname");

    console.log("bestellen", bestellen);

    $(".modal-message").html(`#${sid} - ${orgName}<br>${date}`);

    // Match bestellen items with image/title
    const enrichedBestellen = (Array.isArray(bestellen) ? bestellen : []).map(
      (orderItem) => {
        const match = bestellenItems.find(
          (item) => item.title === orderItem.item
        );
        return {
          ...orderItem,
          image: match?.image || "",
          title: match?.title || orderItem.item,
        };
      }
    );

    // Match terugsturen items with image/title
    const enrichedTerugsturen = (
      Array.isArray(terugsturen) ? terugsturen : []
    ).map((orderItem) => {
      const match = terugsturenItems.find(
        (item) => item.title === orderItem.item
      );
      return {
        ...orderItem,
        image: match?.image || "",
        title: match?.title || orderItem.item,
      };
    });

    let bestellenRows = "";
    enrichedBestellen.forEach((item) => {
      const imageHtml = item.image
        ? `<img src="${item.image}" alt="${item.title}" class="w-[109px] h-[81px] object-cover" />`
        : `<div class="bg-rdmGray w-[109px] h-[81px]"></div>`;

      bestellenRows += `
        <tr>
          <td class="px-0">${imageHtml}</td>
          <td class="text-rdmGreen font-bold">${item.title}</td>
          <td class="text-right">${item.quantity}</td>
        </tr>`;
    });

    let terugsturenRows = "";
    enrichedTerugsturen.forEach((item) => {
      const imageHtml = item.image
        ? `<img src="${item.image}" alt="${item.title}" class="w-[109px] h-[81px] object-cover" />`
        : `<div class="bg-rdmGray w-[109px] h-[81px]"></div>`;

      terugsturenRows += `
        <tr>
          <td class="px-0">${imageHtml}</td>
          <td class="text-rdmGreen font-bold">${item.title}</td>
          <td class="text-right">${item.quantity}</td>
        </tr>`;
    });

    const tables = $("#overzicht-modal table tbody");
    tables.eq(0).html(bestellenRows);
    tables.eq(1).html(terugsturenRows);
  });

  // XLS download
  $("#download-overzicht").on("click", function (e) {
    e.preventDefault();

    let tableHTML = "<table>";

    // Build thead
    const $table = $("#Bestellingen table");
    const $thead = $table.find("thead");
    if ($thead.length) {
      tableHTML += "<thead>";
      $thead.find("tr").each(function () {
        tableHTML += "<tr>";
        $(this)
          .find("th")
          .each(function () {
            tableHTML += `<th>${$(this).text().trim()}</th>`;
          });
        tableHTML += "</tr>";
      });
      tableHTML += "</thead>";
    }

    // Build tbody
    const $tbody = $table.find("tbody");
    if ($tbody.length) {
      tableHTML += "<tbody>";
      $tbody.find("tr").each(function () {
        tableHTML += "<tr>";
        $(this)
          .find("td")
          .each(function () {
            tableHTML += `<td>${$(this).text().trim()}</td>`;
          });
        tableHTML += "</tr>";
      });
      tableHTML += "</tbody>";
    }

    tableHTML += "</table>";

    // Wrap in Excel-compatible HTML
    const fullHTML = `
  <html xmlns:o="urn:schemas-microsoft-com:office:office"
        xmlns:x="urn:schemas-microsoft-com:office:excel"
        xmlns="http://www.w3.org/TR/REC-html40">
  <head>
    <!--[if gte mso 9]>
    <xml>
      <x:ExcelWorkbook>
        <x:ExcelWorksheets>
          <x:ExcelWorksheet>
            <x:Name>Sheet1</x:Name>
            <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
          </x:ExcelWorksheet>
        </x:ExcelWorksheets>
      </x:ExcelWorkbook>
    </xml>
    <![endif]-->
  </head>
  <body>
    ${tableHTML}
  </body>
  </html>`;

    // Create and trigger the download
    const blob = new Blob([fullHTML], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "bestellingen.xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  });

  // Close modal
  $(".close-modal").click(function () {
    $("body").removeClass("modal-open");
    $("#overzicht-modal").fadeOut().attr("aria-hidden", "true");
  });

  // Close modal on outside click
  $(document).on("click", function (e) {
    const $modal = $("#overzicht-modal");

    if ($("body").hasClass("modal-open") && $modal.is(":visible")) {
      if (!$modal.is(e.target) && $modal.has(e.target).length === 0) {
        $("body").removeClass("modal-open");
        $modal.fadeOut().attr("aria-hidden", "true");
      }
    }
  });

  // Smooth scroll to anchors
  $("a[href*=\\#]:not([href=\\#])").on("click", function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html,body").animate(
          {
            scrollTop: target.offset().top,
          },
          1000
        );

        target.trigger("focus");
        return false;
      }
    }
  });

  // Datepicker init
  $("#daterange").daterangepicker({
    autoUpdateInput: false,
    parentEl: ".calendar-wrapper",
    opens: "right",
    locale: {
      cancelLabel: "Clear",
      format: "DD-MM-YYYY",
      applyLabel: "Toepassen",
      cancelLabel: "Annuleren",
      fromLabel: "Van",
      toLabel: "Tot",
      customRangeLabel: "Aangepast",
      weekLabel: "Wk",
      daysOfWeek: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
      monthNames: [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December",
      ],
    },
  });

  // Store original rows on page load
  const originalRows = $("#Bestellingen table tbody tr").clone();

  // Filter table rows by date
  function filterTableRowsByDate(startDate, endDate) {
    const format = "DD-MM-YYYY";

    // Clear table
    $("#Bestellingen table tbody").empty();

    // Loop over original rows
    originalRows.each(function () {
      const dateText = $(this).find("td:last").text().trim();
      const date = moment(dateText, format);

      const inRange =
        date.isValid() && date.isBetween(startDate, endDate, "day", "[]"); // inclusive

      if (inRange) {
        $("#Bestellingen table tbody").append($(this).clone());
      }
    });
  }

  // Apply selected date range
  $("#daterange").on("apply.daterangepicker", function (ev, picker) {
    $(this).val(
      picker.startDate.format("DD-MM-YYYY") +
        " - " +
        picker.endDate.format("DD-MM-YYYY")
    );

    filterTableRowsByDate(picker.startDate, picker.endDate);
  });

  // Clear filter
  $("#daterange").on("cancel.daterangepicker", function () {
    $(this).val("");
    $("#Bestellingen table tbody").empty().append(originalRows.clone());
  });
});
